import * as React from 'react';
import BidConsoleOpener from '@/components/BidConsoleOpener/BidConsoleOpener';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { FormattedMessage } from 'react-intl';
import { getCatalog } from '@/redux/modules/catalog';
import isEqual from 'react-fast-compare';
import noop from '@/utils/noop';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
};

const ItemBiddingEnterButton = (props: Props) => {
    const { catalogId } = props;

    const { catalogStatus, isCatalogOnly } = useSelector((state) => getCatalog(state, catalogId), isEqual);

    return catalogStatus === 'live' && !isCatalogOnly ? (
        <BidConsoleOpener catalogId={catalogId}>
            <StyledButton id="ItemBiddingEnter" onClick={noop} secondary>
                <FormattedMessage id="enter_live_auction" />
            </StyledButton>
        </BidConsoleOpener>
    ) : null;
};

export default React.memo<Props>(ItemBiddingEnterButton);

const StyledButton = styled(Button)`
    height: 46px;
    text-transform: uppercase;
    min-width: 100%;
`;
